var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.500092,
    width: 40,
    height: 40,
    rx: 15,
    fill: "#F8B400",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3084 20.6527C30.8744 20.5528 30.4223 20.5001 29.958 20.5001C26.6443 20.5001 23.958 23.1864 23.958 26.5001C23.958 28.1405 24.6163 29.6271 25.6831 30.7102L20.4541 33.5001V21.4518L31.3084 15.866V20.6527ZM18.7842 33.4617V21.4117L8 15.7975V27.7089L18.7842 33.4617ZM23.9909 17.753L13.0932 12.0787L8.88337 14.3748L19.6559 19.984L23.9909 17.753ZM25.8094 16.8178L30.4284 14.4416L19.6542 8.50009L14.8583 11.1151L25.8094 16.8178Z",
    fill: "#028789"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.958 23.5001V26.5001M29.958 29.5001V26.5001M29.958 26.5001H32.958M29.958 26.5001H26.958",
    stroke: "#028789",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProduct);
export default __webpack_public_path__ + "static/media/add_product.8d2d0b663559a3042e13998e4f943085.svg";
export { ForwardRef as ReactComponent };